import React, { useEffect, useState } from "react";
import {
  Box, Typography, Button, Card, CardContent, useTheme, Grid,
  alpha, Stack, Container, Chip, Avatar,
  Dialog, IconButton,
  CircularProgress,
  SwipeableDrawer,
  Rating,
  useMediaQuery,
  Slider
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  QrCodeScanner, EmojiEvents, ArrowForwardIos,
  SportsEsports, Movie, Groups,
  InfoOutlined, CardGiftcard, PlayCircleFilled, Close,
  Star, Add, Remove, StarBorder, Cake, Favorite, WhatsApp, Phone
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { getRoomsForBooking } from "../redux/slices/room/thunk";
import wheelImg from "../assets/wheel.png";
import UserQRCode from "../components/UserQRCode";
import BookingContactModal from "../components/BookingContactModal";
import { getAllWheels, getMyRewards, getSpinStatus } from "../redux/slices/wheel/thunk";
import image1 from "../assets/image1.jpeg";
import image2 from "../assets/image2.jpeg";
import image3 from "../assets/image3.jpeg";
import image4 from "../assets/image4.jpeg";
import LoadingPage from "../components/LoadingComponent"; import { getAllBookings } from "../redux/slices/booking/thunk";
import { getAllProducts, orderRequest } from "../redux/slices/product/thunk";
import useBaseImageUrl from "../hooks/useBaseImageUrl";
import { useGetData as getData } from "../hooks/useGetData";
import { getAllAds } from "../redux/slices/ads/thunk";
import { getLastRate, rating, skipRating } from "../redux/slices/rating/thunk";
import { getReceptions, getUserData } from "../redux/slices/user/thunk";

const BASE_URL = "https://red-90.com";
const joinUrl = (path) => path?.startsWith("http") ? path : `${BASE_URL}${path}`;

// --- Component MediaGallery ---
const MediaGallery = ({ open, onClose, item, onBookAd, isRtl, primaryMain }) => {
  if (!item) return null;
  const isBirthday = item.type === "birthday";
  const isDate = item.type === "date";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'rgba(15,15,15,0.96)',
          backgroundImage: 'none',
          boxShadow: '0 25px 50px rgba(0,0,0,0.7)',
          overflow: 'visible',
          borderRadius: 4,
          m: 1
        }
      }}
    >
      <Box sx={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', p: { xs: 1.5, md: 2.5 } }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute', top: -45, right: 0, color: '#fff',
            bgcolor: alpha('#fff', 0.1), '&:hover': { bgcolor: alpha('#fff', 0.2) }
          }}
        >
          <Close />
        </IconButton>

        {item.mediaType === "video" ? (
          <Box sx={{ width: '100%', position: 'relative', borderRadius: 3, overflow: 'hidden' }}>
            <video
              controls
              autoPlay
              style={{
                width: '100%',
                maxHeight: '65vh',
                display: 'block',
                borderRadius: 'inherit'
              }}
            >
              <source src={joinUrl(item.mediaUrl)} type="video/mp4" />
            </video>
          </Box>
        ) : (
          <Box
            component="img"
            src={joinUrl(item.mediaUrl)}
            sx={{ width: '100%', maxHeight: '65vh', objectFit: 'contain', borderRadius: 3 }}
          />
        )}

        {(isBirthday || isDate) && (
          <Button
            variant="contained"
            onClick={() => onBookAd && onBookAd(item)}
            startIcon={isBirthday ? <Cake /> : <Favorite />}
            sx={{
              mt: 2.5,
              borderRadius: 3,
              py: 1.3,
              px: { xs: 3, sm: 5 },
              fontWeight: 900,
              fontSize: '1rem',
              bgcolor: isBirthday ? "#FF5722" : primaryMain,
              boxShadow: isBirthday ? "0 8px 24px rgba(255,87,34,0.4)" : `0 8px 24px ${alpha(primaryMain, 0.4)}`,
              color: '#fff',
              '&:hover': { bgcolor: isBirthday ? "#E64A19" : primaryMain }
            }}
          >
            {isBirthday
              ? (isRtl ? "احجز لتجهيز عيد ميلاد الآن (فون / واتساب)" : "Book Birthday Now (Phone / WhatsApp)")
              : (isRtl ? "احجز لتجهيز موعد رومانسي Date (فون / واتساب)" : "Book Romantic Date Now (Phone / WhatsApp)")
            }
          </Button>
        )}
      </Box>
    </Dialog>
  );
};

// --- Component AdSection ---
const AdSection = ({ title, data, onMediaClick, isRtl, primaryMain, type, onBookClick }) => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5, px: { xs: 1, md: 0 } }}>
      <Box sx={{ textAlign: isRtl ? "right" : "left" }}>
        <Typography variant="h4" sx={{ fontWeight: 900, color: "#fff", fontSize: { xs: '1.6rem', md: '2.1rem' } }}>
          {title}
        </Typography>
        <Box sx={{ width: 50, height: 5, bgcolor: type === "birthday" ? "#FF5722" : primaryMain, borderRadius: 10, mt: 1, ml: isRtl ? "auto" : 0 }} />
      </Box>
      <Button
        variant="contained"
        onClick={onBookClick}
        startIcon={type === "birthday" ? <Cake /> : <Favorite />}
        sx={{
          borderRadius: 3,
          fontWeight: 900,
          px: { xs: 2, sm: 3 },
          py: 1,
          fontSize: { xs: "0.85rem", sm: "0.95rem" },
          bgcolor: type === "birthday" ? "#FF5722" : primaryMain,
          color: "#fff",
          boxShadow: type === "birthday" ? "0 4px 14px rgba(255,87,34,0.4)" : `0 4px 14px ${alpha(primaryMain, 0.4)}`,
          "&:hover": { bgcolor: type === "birthday" ? "#E64A19" : primaryMain }
        }}
      >
        {isRtl
          ? (type === "birthday" ? "تجهيز عيد ميلاد" : "تجهيز موعد (Date)")
          : (type === "birthday" ? "Book Birthday" : "Book Date")}
      </Button>
    </Stack>

    <Box
      sx={{
        display: "flex",
        overflowX: "auto",
        gap: 2,
        px: { xs: 1, md: 0 },
        py: 1,
        scrollSnapType: "x mandatory",
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {data.map((ad) => (
        <Card
          key={ad._id}
          onClick={() => onMediaClick(ad)}
          sx={{
            minWidth: { xs: "170px", sm: "240px" },
            maxWidth: { xs: "170px", sm: "240px" },
            borderRadius: 3,
            cursor: "pointer",
            scrollSnapAlign: "start",
            flexShrink: 0,
            transition: "0.3s",
            "&:hover": { transform: "translateY(-6px)", boxShadow: "0 10px 25px rgba(0,0,0,0.5)" }
          }}
        >
          <Box sx={{ height: { xs: 180, sm: 220 }, position: "relative", bgcolor: "#000" }}>
            {ad.mediaType === "video" ? (
              <>
                <video muted loop playsInline style={{ width: "100%", height: "100%", objectFit: "cover", opacity: 0.85 }}>
                  <source src={joinUrl(ad.mediaUrl)} type="video/mp4" />
                </video>
                <PlayCircleFilled sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "white", fontSize: 40, opacity: 0.9 }} />
              </>
            ) : (
              <Box component="img" src={joinUrl(ad.mediaUrl)} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
            )}
          </Box>
        </Card>
      ))}
    </Box>
  </Box>
);

// --- Component DateOrBirthdayCard (when no ads exist) ---
const DateOrBirthdayCard = ({ type, title, subtitle, onBook, isRtl, color }) => (
  <Card
    sx={{
      mb: 4,
      borderRadius: 4,
      p: { xs: 2.5, md: 3.5 },
      bgcolor: "rgba(20, 20, 20, 0.7)",
      backdropFilter: "blur(12px)",
      border: `1px solid ${alpha(color, 0.3)}`,
      boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
      direction: isRtl ? "rtl" : "ltr",
    }}
  >
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={3}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={2} gap={1} alignItems="center">
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: 3,
            bgcolor: alpha(color, 0.15),
            color: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {type === "birthday" ? <Cake sx={{ fontSize: 32 }} /> : <Favorite sx={{ fontSize: 32 }} />}
        </Box>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 900, color: "#fff", mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>
            {subtitle}
          </Typography>
        </Box>
      </Stack>

      <Button
        variant="contained"
        onClick={onBook}
        startIcon={type === "birthday" ? <Cake /> : <Favorite />}
        sx={{
          borderRadius: 3,
          px: 3.5,
          py: 1.2,
          gap: 1,
          fontWeight: 900,
          bgcolor: color,
          color: "#fff",
          whiteSpace: "nowrap",
          alignSelf: { xs: "stretch", sm: "auto" },
          boxShadow: `0 6px 20px ${alpha(color, 0.4)}`,
          "&:hover": { bgcolor: color, opacity: 0.9 },
        }}
      >
        {isRtl ? "احجز وتواصل الآن" : "Book Now"}
      </Button>
    </Stack>
  </Card>
);

export default function Home() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [qrOpen, setQrOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [orderDialogOpen, setOrderDialogOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedAd, setSelectedAd] = useState(null);
  const [orderLoading, setOrderLoading] = useState(false);
  const [pointsLoading, setPointsLoading] = useState(false);
  const [bookDialogOpen, setBookDialogOpen] = useState(false);
  const [bookingModalType, setBookingModalType] = useState("room");
  const [bookingModalTitle, setBookingModalTitle] = useState("");
  const [selectedRoom, setSelectedRoom] = useState(null);

  const handleOpenBooking = (type, title, roomData = null) => {
    setBookingModalType(type);
    setBookingModalTitle(title || "");
    setSelectedRoom(roomData);
    setBookDialogOpen(true);
  };

  const user = JSON.parse(localStorage.getItem("user")) || { name: "Guest", points: 0 };
  const [currentPoints, setCurrentPoints] = useState(user.points);

  const handleRefreshPoints = async () => {
    if (!user?._id || pointsLoading) return;
    setPointsLoading(true);
    try {
      const res = await dispatch(getUserData(user._id)).unwrap();
      if (res?.data) {
        if (res.data.points !== undefined) {
          setCurrentPoints(res.data.points);
        }
      }
    } catch (error) {
      console.error("Failed to fetch points:", error);
    } finally {
      setTimeout(() => setPointsLoading(false), 600);
    }
  };

  // Rating State
  const [selectedReception, setSelectedReception] = useState(null);
  const [ratingValue, setRatingValue] = useState(5);
  const [isRatingSubmitting, setIsRatingSubmitting] = useState(false);

  const { roomsForBooking } = useSelector((state) => state.room);
  const { ads } = useSelector((state) => state.ads);
  const { products } = useSelector((state) => state.product);
  const { lastRate } = useSelector((state) => state.rating);
  const { receptions } = useSelector((state) => state.user);
  const { wheels, myRewards, spinStatus } = useSelector((state) => state.wheel);
  const baseUrl = useBaseImageUrl();

  const primaryMain = theme.palette.primary.main;

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        if (user?._id) {
          dispatch(getUserData(user._id));
        }
        const rateResult = await dispatch(getLastRate()).unwrap();
        if (rateResult?.ratingData?.bookingId) {
          dispatch(getReceptions());
        }
        await Promise.all([
          dispatch(getSpinStatus()).unwrap(),
          dispatch(getRoomsForBooking()).unwrap(),
          dispatch(getAllAds()).unwrap(),
          dispatch(getAllWheels()).unwrap(),
          dispatch(getMyRewards()).unwrap(),
          dispatch(getAllProducts({ query: 'page=1&limit=3' })).unwrap(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllData();
  }, [dispatch]);

  const handleOrderRequest = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setOrderDialogOpen(true);
  };

  const confirmOrder = async () => {
    const data = { product: selectedProduct._id, quantity: String(quantity) }
    try {
      setOrderLoading(true)
      await dispatch(orderRequest({ data })).unwrap();
      setOrderDialogOpen(false);
      navigate('/MyOrders')
    } catch (e) {
      console.error(e)
    } finally {
      setOrderLoading(false)
    }
  };

  // Rating Handlers
  const handleSendRating = async () => {
    if (!selectedReception) return;
    setIsRatingSubmitting(true);
    try {
      await dispatch(rating({
        bookingId: lastRate.ratingData.bookingId,
        reception: selectedReception,
        rating: ratingValue
      })).unwrap();
      dispatch(getLastRate());
    } catch (e) {
      console.error(e);
    } finally {
      setIsRatingSubmitting(false);
    }
  };

  const handleSkipRating = async () => {
    setIsRatingSubmitting(true);
    try {
      await dispatch(skipRating({ bookingId: lastRate.ratingData.bookingId })).unwrap();
      dispatch(getLastRate());
    } catch (e) {
      console.error(e);
    } finally {
      setIsRatingSubmitting(false);
    }
  };

  const formatNextSpin = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat(i18n.language, {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    }).format(date);
  };

  if (isLoading) return <LoadingPage />

  // --- Rating UI Component ---
  const RatingContent = () => (
    <Box sx={{ p: 3, pt: 1, textAlign: 'center' }}>
      {/* Pull Indicator for SwipeableDrawer */}
      {isMobile && <Box sx={{ width: 40, height: 4, bgcolor: 'divider', borderRadius: 2, mx: 'auto', mb: 3 }} />}

      <Typography variant="h5" sx={{ fontWeight: 1000, mb: 1, letterSpacing: -0.5 }}>
        {isRtl ? "كيف كانت تجربتك؟" : "How was your experience?"}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontWeight: 600 }}>
        {isRtl ? "من فضلك قيم موظف الاستقبال" : "Please rate our receptionist"}
      </Typography>

      <Stack direction="row" spacing={2} sx={{ overflowX: "auto", pb: 2, px: 1, justifyContent: receptions?.length < 3 ? 'center' : 'flex-start' }}>
        {receptions?.map((rec) => (
          <Box
            key={rec._id}
            onClick={() => setSelectedReception(rec._id)}
            sx={{
              cursor: 'pointer', textAlign: 'center', minWidth: 90,
              position: 'relative',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: selectedReception === rec._id ? 'scale(1.05)' : 'scale(1)',
            }}
          >
            <Box sx={{ position: 'relative', mx: 'auto', width: 70, height: 70 }}>
              <Avatar
                src={joinUrl(rec.image)}
                sx={{
                  width: '100%', height: '100%', border: selectedReception === rec._id ? `3px solid ${primaryMain}` : `2px solid transparent`,
                  boxShadow: selectedReception === rec._id ? `0 8px 16px ${alpha(primaryMain, 0.4)}` : 'none',
                  transition: '0.3s'
                }}
              />
              {selectedReception === rec._id && (
                <Box sx={{ position: 'absolute', bottom: -5, right: -5, bgcolor: primaryMain, borderRadius: '50%', p: 0.5, display: 'flex' }}>
                  <Star sx={{ fontSize: 14, color: '#fff' }} />
                </Box>
              )}
            </Box>
            <Typography variant="caption" sx={{ mt: 1.5, fontWeight: 800, display: 'block', color: selectedReception === rec._id ? 'text.primary' : 'text.secondary' }}>
              {rec.name}
            </Typography>
          </Box>
        ))}
      </Stack>

      <Box sx={{ my: 4, p: 2, bgcolor: alpha(primaryMain, 0.03), borderRadius: 4 }}>
        <Rating
          value={ratingValue}
          onChange={(e, v) => setRatingValue(v)}
          size="large"
          icon={<Star sx={{ fontSize: '2.5rem', color: '#FFD700' }} />}
          emptyIcon={<StarBorder sx={{ fontSize: '2.5rem' }} />}
        />
        <Typography variant="h6" sx={{ mt: 1, fontWeight: 900, color: primaryMain }}>
          {ratingValue} / 5
        </Typography>
      </Box>

      <Stack spacing={2} sx={{ mb: isMobile ? 4 : 0 }}>
        <Button
          fullWidth
          variant="contained"
          disabled={!selectedReception || isRatingSubmitting}
          onClick={handleSendRating}
          sx={{ borderRadius: 4, py: 1.8, fontWeight: 900, fontSize: '1rem', boxShadow: `0 8px 20px ${alpha(primaryMain, 0.3)}` }}
        >
          {isRatingSubmitting ? <CircularProgress size={24} /> : (isRtl ? "تأكيد التقييم" : "Confirm Rating")}
        </Button>
        <Button
          fullWidth
          onClick={handleSkipRating}
          disabled={isRatingSubmitting}
          sx={{ fontWeight: 800, color: 'text.secondary', py: 1 }}
        >
          {isRtl ? "تخطي الآن" : "Skip for now"}
        </Button>
      </Stack>
    </Box>
  );

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", pb: { xs: 0, md: 0 } }}>

      {/* SECTION 1: HEADER & GRID */}
      <Box sx={{
        background: `linear-gradient(rgba(15, 5, 5, 0.85), rgba(15, 5, 5, 0.85)), url(${image1}) center/cover fixed`,
        pb: 6
      }}>
        {/* 1. TOP HEADER SECTION */}
        <Container maxWidth="lg" sx={{ pt: 4, pb: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ flexDirection: isRtl ? "row-reverse" : "row" }}>
            <Avatar
              src={user.image && user.image !== "null" ? `${baseUrl}${user.image}` : undefined}
              sx={{
                width: 60, height: 60, border: `2px solid ${primaryMain}`,
                boxShadow: `0 0 15px ${alpha(primaryMain, 0.3)}`,
              }}
            >
              {user.name?.[0]}
            </Avatar>
            <Box sx={{ textAlign: isRtl ? "right" : "left" }}>
              <Typography variant="h5" sx={{ color: "#ffffff", fontWeight: 950, lineHeight: 1.2 }}>
                {t("home.welcome")} {user.name.split(" ")[0]} 👋
              </Typography>
              <Typography variant="body2" color="#f0efefe8" fontWeight={700}>
                {t("home.sub_welcome")}
              </Typography>
            </Box>
          </Stack>
        </Container>

        {/* CURTAIN ANIMATION */}
        <div className="curtain-container">
          <div className="curtain-left"></div>
          <div className="curtain-right"></div>
        </div>

        {/* 3. INTERACTIVE GRID */}
        <Container maxWidth="lg" sx={{ mt: 2, mb: 6 }}>
          <Grid container spacing={2} sx={{ direction: isRtl ? "rtl" : "ltr" }}>

            {/* LUCKY WHEEL */}
            <Grid item xs={12} md={6}>
              <Box
                onClick={() => spinStatus?.canSpin && navigate("/spin")}
                sx={{
                  height: "100%", minHeight: "280px", borderRadius: "24px",
                  position: "relative", overflow: "hidden", cursor: spinStatus?.canSpin ? "pointer" : "default",
                  background: spinStatus?.canSpin
                    ? `linear-gradient(135deg, ${primaryMain} 0%, #600000 100%)`
                    : `linear-gradient(135deg, #444 0%, #222 100%)`,
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  border: `1px solid ${alpha("#fff", 0.1)}`,
                  display: "flex", alignItems: "center",
                  "&:hover": spinStatus?.canSpin ? {
                    transform: "scale(1.01)",
                    boxShadow: `0 20px 40px ${alpha(primaryMain, 0.4)}`,
                    "& .wheel-image": {
                      transform: isRtl ? "scaleX(-1) rotate(-90deg) scale(1.1)" : "rotate(90deg) scale(1.1)",
                      filter: "drop-shadow(0 0 30px #fff)",
                    },
                  } : {},
                }}
              >
                <Box sx={{ position: "absolute", top: -50, right: isRtl ? "auto" : -50, left: isRtl ? -50 : "auto", width: 200, height: 200, borderRadius: "50%", background: spinStatus?.canSpin ? "#FF4D4D" : "#666", filter: "blur(80px)", opacity: 0.3 }} />

                <CardContent sx={{ zIndex: 2, p: 4, width: "65%", textAlign: isRtl ? "right" : "left" }}>
                  <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, px: 1.5, py: 0.5, borderRadius: "50px", bgcolor: alpha("#000", 0.3), border: "1px solid rgba(255,255,255,0.2)", mb: 2 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: spinStatus?.canSpin ? "#FFD700" : "#888", animation: spinStatus?.canSpin ? "pulse 1.5s infinite" : "none" }} />
                    <Typography variant="caption" sx={{ color: "#fff", fontWeight: 800, textTransform: "uppercase" }}>
                      {spinStatus?.canSpin ? t("home.lucky_wheel.badge") : t("home.lucky_wheel.locked")}
                    </Typography>
                  </Box>
                  <Typography variant="h3" sx={{ fontWeight: 1000, color: "#fff", mb: 1, fontSize: { xs: "2rem", md: "2.8rem" }, lineHeight: 1 }}>
                    {t("home.lucky_wheel.title")}
                  </Typography>
                  <Typography variant="body2" sx={{ color: alpha("#fff", 0.8), mb: 4, fontWeight: 500 }}>
                    {t("home.lucky_wheel.subtitle")}
                  </Typography>
                  {spinStatus?.canSpin ? (
                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, color: "#fff", fontWeight: 900, fontSize: "0.9rem", borderBottom: "2px solid #fff", pb: 0.5 }}>
                      {t("home.lucky_wheel.action")}
                      <ArrowForwardIos sx={{ fontSize: 14, transform: isRtl ? "rotate(180deg)" : "none" }} />
                    </Box>
                  ) : (
                    <Stack spacing={1}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ color: "#FFD700", fontWeight: 900, fontSize: "0.95rem" }}>
                          {`${spinStatus?.remainingTime?.hours}${t('units.h')} : ${spinStatus?.remainingTime?.minutes}${t('units.m')}`}
                        </Typography>
                        <Typography sx={{ color: alpha("#fff", 0.6), fontSize: "0.8rem" }}>({t('home.lucky_wheel.remaining')})</Typography>
                      </Box>
                      <Typography sx={{ color: alpha("#fff", 0.5), fontSize: "0.75rem", fontWeight: 600 }}>
                        {`${t('home.lucky_wheel.next_spin')}: ${formatNextSpin(spinStatus?.nextSpinAt)}`}
                      </Typography>
                    </Stack>
                  )}
                </CardContent>
                <Box component="img" src={wheelImg} className="wheel-image" sx={{ position: "absolute", right: isRtl ? "auto" : "-5%", left: isRtl ? "-5%" : "auto", width: { xs: "220px", md: "310px" }, zIndex: 2, transition: "all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)", filter: spinStatus?.canSpin ? "drop-shadow(0 20px 40px rgba(0,0,0,0.5))" : "grayscale(1) opacity(0.5)", transform: isRtl ? "scaleX(-1)" : "none" }} />
              </Box>
            </Grid>

            {/* QUICK PAY */}
            <Grid item xs={6} md={3}>
              <Button fullWidth onClick={() => setQrOpen(true)} sx={{ height: "100%", minHeight: "160px", borderRadius: 3, flexDirection: "column", gap: 2, border: `1px solid ${alpha("#fff", 0.1)}`, bgcolor: "rgba(0,0,0,0.4)", backdropFilter: "blur(10px)", "&:hover": { bgcolor: "rgba(0,0,0,0.6)", border: `1px solid ${primaryMain}` } }}>
                <Box sx={{ p: 3, borderRadius: "50%", bgcolor: alpha(primaryMain, 0.2), color: primaryMain, animation: "pulse 2s infinite", "@keyframes pulse": { "0%": { boxShadow: `0 0 0 0 ${alpha(primaryMain, 0.4)}` }, "70%": { boxShadow: `0 0 0 15px ${alpha(primaryMain, 0)}` }, "100%": { boxShadow: `0 0 0 0 ${alpha(primaryMain, 0)}` } } }}>
                  <QrCodeScanner sx={{ fontSize: 50 }} />
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 900, color: "#fff" }}>{t("home.quick_pay.title")}</Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontWeight: 800 }}>{t("home.quick_pay.subtitle")}</Typography>
                </Box>
              </Button>
            </Grid>

            {/* POINTS */}
            <Grid item xs={6} md={3}>
              <Button fullWidth onClick={handleRefreshPoints} sx={{ height: "100%", minHeight: "160px", borderRadius: 3, flexDirection: "column", gap: 2, border: `1px solid ${alpha("#fff", 0.1)}`, bgcolor: "rgba(0,0,0,0.4)", backdropFilter: "blur(10px)", "&:hover": { transform: "translateY(-5px)", boxShadow: theme.shadows[4] } }}>
                <Box sx={{ color: "#FFD700", display: "flex", alignItems: "center", justifyContent: "center", height: 50 }}>
                  {pointsLoading ? <CircularProgress color="inherit" size={40} /> : <EmojiEvents sx={{ fontSize: 50 }} />}
                </Box>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 1000, color: "#fff", lineHeight: 1 }}>{currentPoints}</Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontWeight: 800 }}>{t("home.points.label")}</Typography>
                </Box>
              </Button>
            </Grid>

            {/* MY REWARDS */}
            {myRewards?.length > 0 && (
              <Grid item xs={12}>
                <Box onClick={() => navigate("/rewards")} sx={{ p: 2.5, borderRadius: "24px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", background: "linear-gradient(90deg, rgba(0,0,0,0.6) 0%, rgba(20,20,20,0.4) 100%)", backdropFilter: "blur(10px)", border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`, transition: "0.3s", "&:hover": { transform: "translateY(-3px)", boxShadow: `0 10px 20px ${alpha(theme.palette.success.main, 0.1)}`, borderColor: theme.palette.success.main } }}>
                  <Stack direction="row" spacing={2} gap={1} alignItems="center">
                    <Box sx={{ p: 1.5, borderRadius: "16px", bgcolor: theme.palette.success.main, color: "#fff", display: "flex", boxShadow: `0 4px 12px ${alpha(theme.palette.success.main, 0.4)}` }}>
                      <CardGiftcard />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 1000, lineHeight: 1.2, color: "#fff" }}>{isRtl ? "لديك مكافآت جاهزة!" : "You have rewards ready!"}</Typography>
                      <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontWeight: 700 }}>{isRtl ? `يوجد ${myRewards.length} من الهدايا بانتظارك` : `There are ${myRewards.length} gifts waiting for you`}</Typography>
                    </Box>
                  </Stack>
                  <ArrowForwardIos sx={{ fontSize: 16, color: theme.palette.success.main, transform: isRtl ? "rotate(180deg)" : "none" }} />
                </Box>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>

      {/* 3. ROOMS SECTION */}
      <Box sx={{
        background: `linear-gradient(rgba(15, 5, 5, 0.85), rgba(15, 5, 5, 0.85)), url(${image2}) center/cover fixed`,
        py: 6
      }}>
        <Container maxWidth="lg">
          <Stack direction="row" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 4 }}>
            <Box sx={{ textAlign: isRtl ? "right" : "left" }}>
              <Typography variant="h4" sx={{ fontWeight: 900, color: "#fff" }}>{t("home.rooms.title")}</Typography>
              <Box sx={{ width: 50, height: 5, bgcolor: primaryMain, borderRadius: 10, mt: 1, ml: isRtl ? "auto" : 0 }} />
            </Box>
            <Button onClick={() => navigate("/rooms")} endIcon={<ArrowForwardIos sx={{ fontSize: 12, transform: isRtl ? "rotate(180deg)" : "none" }} />} sx={{ fontWeight: 800, color: primaryMain }}>
              {t("home.rooms.view_all")}
            </Button>
          </Stack>

          <Grid container spacing={3}>
            {roomsForBooking?.filter((room) => (room?.isAvailable === true))?.map((room) => (
              <Grid item xs={12} sm={6} md={4} key={room._id}>
                <Card
                  onClick={() => handleOpenBooking("room", isRtl ? room.title_ar : room.title_en, room)}
                  sx={{
                    height: "100%", borderRadius: 3, p: 1.2, bgcolor: "background.paper",
                    cursor: "pointer",
                    "&:hover": { transform: "translateY(-8px)" }, transition: "0.3s"
                  }}
                >
                  <Box sx={{ position: "relative", height: 200, borderRadius: 3, overflow: "hidden" }}>
                    <Box component="img" src={joinUrl(room.image)} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    <Chip label={room.isBusy ? t("home.rooms.status_busy") : t("home.rooms.status_ready")} sx={{ position: "absolute", top: 12, right: 12, bgcolor: room.isBusy ? "#000" : (theme.palette.primary.confirm || "#16A34A"), color: "#fff", fontWeight: 900, borderRadius: 2 }} />
                    <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, p: 1.5, background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)" }}>
                      <Chip size="small" label={room.type.toUpperCase()} sx={{ bgcolor: alpha(primaryMain, 0.8), color: "#fff", fontWeight: 700 }} />
                    </Box>
                  </Box>
                  <CardContent sx={{ px: 1, pt: 2, textAlign: isRtl ? "right" : "left" }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 2 }}>
                      <Typography variant="h6" sx={{ fontWeight: 900 }}>{isRtl ? room.title_ar : room.title_en}</Typography>
                      <Stack direction="row" spacing={0.5} alignItems="center" color="text.secondary">
                        <Groups fontSize="small" />
                        <Typography variant="caption" fontWeight={800}>{room.capacity}</Typography>
                      </Stack>
                    </Stack>
                    <Stack spacing={1} sx={{ mb: 3 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", p: 1.2, borderRadius: 3, bgcolor: theme.palette.secondary.sec }}>
                        <Typography variant="caption" fontWeight={800}>{t("home.rooms.single")}</Typography>
                        <Typography variant="subtitle2" fontWeight={1000}>{room.price_single_hour} EGP</Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", p: 1.2, borderRadius: 3, bgcolor: theme.palette.secondary.sec }}>
                        <Typography variant="caption" fontWeight={800}>{t("home.rooms.multi")}</Typography>
                        <Typography variant="subtitle2" fontWeight={1000}>{room.price_multi_hour} EGP</Typography>
                      </Box>
                    </Stack>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenBooking("room", isRtl ? room.title_ar : room.title_en, room);
                      }}
                      sx={{ borderRadius: 4, py: 1.5, fontWeight: 900 }}
                    >
                      {t("home.rooms.book_now")}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* 4. NEW SECTIONS (Birthday & Dates) */}
      <Box sx={{
        background: `linear-gradient(rgba(15, 5, 5, 0.85), rgba(15, 5, 5, 0.85)), url(${image3}) center/cover fixed`,
        py: 6
      }}>
        <Container maxWidth="lg">
          {ads.filter(a => a.type === "date")?.length > 0 ? (
            <AdSection
              title={isRtl ? "موعد غرامي (Date)" : "Romantic Dates"}
              data={ads.filter(a => a.type === "date")}
              onMediaClick={setSelectedAd}
              isRtl={isRtl}
              primaryMain={primaryMain}
              type="date"
              onBookClick={() => handleOpenBooking("date", isRtl ? "موعد رومانسي (Date)" : "Romantic Date")}
            />
          ) : (
            <DateOrBirthdayCard
              type="date"
              title={isRtl ? "تجهيز موعد رومانسي (Date)" : "Romantic Date Setup"}
              subtitle={isRtl ? "فاجئ من تحب بأجواء رومانسية وديكورات خاصة داخل RED 90" : "Surprise your loved one in a special romantic atmosphere at RED 90"}
              onBook={() => handleOpenBooking("date", isRtl ? "موعد رومانسي (Date)" : "Romantic Date")}
              isRtl={isRtl}
              color={primaryMain}
            />
          )}

          {ads.filter(a => a.type === "birthday")?.length > 0 ? (
            <AdSection
              title={isRtl ? "أعياد ميلاد سعيدة" : "Happy Birthday"}
              data={ads.filter(a => a.type === "birthday")}
              onMediaClick={setSelectedAd}
              isRtl={isRtl}
              primaryMain={primaryMain}
              type="birthday"
              onBookClick={() => handleOpenBooking("birthday", isRtl ? "تجهيز عيد ميلاد" : "Birthday Party")}
            />
          ) : (
            <DateOrBirthdayCard
              type="birthday"
              title={isRtl ? "تجهيز أعياد الميلاد" : "Birthday Party Setup"}
              subtitle={isRtl ? "احتفل بعيد ميلادك بأرقى وأجمل التجهيزات الخاصة داخل RED 90" : "Celebrate your birthday with premium setups at RED 90"}
              onBook={() => handleOpenBooking("birthday", isRtl ? "تجهيز عيد ميلاد" : "Birthday Party")}
              isRtl={isRtl}
              color="#FF5722"
            />
          )}
        </Container>
      </Box>

      {/* 5. PRODUCTS SECTION */}
      {Boolean(products?.data && products.data.length > 0) && (
        <Box sx={{
          background: `linear-gradient(rgba(15, 5, 5, 0.85), rgba(15, 5, 5, 0.85)), url(${image4}) center/cover fixed`,
          py: 6
        }}>
          <Container maxWidth="lg">
            <Stack direction="row" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 4 }}>
              <Box sx={{ textAlign: isRtl ? "right" : "left" }}>
                <Typography variant="h4" sx={{ fontWeight: 900, color: "#fff" }}>{t("home.products.title")}</Typography>
                <Box sx={{ width: 50, height: 5, bgcolor: primaryMain, borderRadius: 10, mt: 1, ml: isRtl ? "auto" : 0 }} />
              </Box>
              <Button onClick={() => navigate("/products")} endIcon={<ArrowForwardIos sx={{ fontSize: 12, transform: isRtl ? "rotate(180deg)" : "none" }} />} sx={{ fontWeight: 800, color: primaryMain }}>
                {t("home.products.view_all")}
              </Button>
            </Stack>

            <Grid container spacing={3}>
              {products?.data?.map((product) => (
                <Grid item xs={12} sm={6} md={4} key={product._id}>
                  <Card sx={{ height: "100%", borderRadius: 4, overflow: "hidden", position: "relative", transition: "0.3s", "&:hover": { boxShadow: `0 15px 30px ${alpha(primaryMain, 0.15)}` } }}>
                    <Chip label={isRtl ? product.category_ar : product.category_en} size="small" sx={{ position: "absolute", top: 15, left: isRtl ? "auto" : 15, right: isRtl ? 15 : "auto", zIndex: 2, bgcolor: alpha("#000", 0.6), color: "#fff", backdropFilter: "blur(5px)", fontWeight: 700 }} />
                    <Box sx={{ height: 220, overflow: "hidden", bgcolor: "#f5f5f5" }}>
                      <Box component="img" src={joinUrl(product.image)} sx={{ width: "100%", height: "100%", objectFit: "contain", transition: "0.5s", "&:hover": { transform: "scale(1.1)" } }} />
                    </Box>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h6" sx={{ fontWeight: 1000, mb: 1 }}>{isRtl ? product.title_ar : product.title_en}</Typography>
                      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                        <Typography variant="h5" color="primary" sx={{ fontWeight: 1000 }}>{product.price} <Typography component="span" variant="caption">EGP</Typography></Typography>
                      </Stack>
                      <Stack direction="row" spacing={1}>
                        <Button fullWidth variant="contained" onClick={() => handleOrderRequest(product)} sx={{ borderRadius: 3, py: 1.2, fontWeight: 900, flex: 2 }}>{t("home.products.order_now")}</Button>
                        <Button variant="outlined" onClick={() => navigate(`/product/${product._id}`)} sx={{ borderRadius: 3, px: 2 }}><InfoOutlined /></Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      )}

      {/* --- RATING SWIPEABLE DRAWER (MOBILE) / DIALOG (DESKTOP) --- */}
      {isMobile ? (
        <SwipeableDrawer
          anchor="bottom"
          open={!!lastRate?.ratingData?.bookingId}
          onClose={() => { }} // Mandatory but we keep it open until action
          onOpen={() => { }}
          disableBackdropClick // User must interact with buttons
          PaperProps={{ sx: { borderTopLeftRadius: 28, borderTopRightRadius: 28, overflow: 'visible' } }}
        >
          <RatingContent />
        </SwipeableDrawer>
      ) : (
        <Dialog
          open={!!lastRate?.ratingData?.bookingId}
          PaperProps={{ sx: { borderRadius: 6, maxWidth: 450, width: '100%' } }}
        >
          <RatingContent />
        </Dialog>
      )}

      {/* --- MEDIA & QR DIALOGS --- */}
      <MediaGallery
        open={!!selectedAd}
        onClose={() => setSelectedAd(null)}
        item={selectedAd}
        isRtl={isRtl}
        primaryMain={primaryMain}
        onBookAd={(ad) => {
          const isBday = ad.type === "birthday";
          setSelectedAd(null);
          handleOpenBooking(
            ad.type || "date",
            isRtl ? (isBday ? "تجهيز عيد ميلاد" : "موعد رومانسي (Date)") : (isBday ? "Birthday Party" : "Romantic Date")
          );
        }}
      />

      {/* --- PRODUCT ORDER DIALOG (RE-DESIGNED) --- */}
      <Dialog open={orderDialogOpen} onClose={() => setOrderDialogOpen(false)} PaperProps={{ sx: { borderRadius: 4, p: 1, maxWidth: 500, width: '95%' } }}>
        <Box sx={{ textAlign: "center", p: 2 }}>
          <IconButton onClick={() => setOrderDialogOpen(false)} sx={{ position: 'absolute', top: 10, right: 10 }}>
            <Close />
          </IconButton>

          <Box sx={{ position: 'relative', mb: 3 }}>
            <Avatar
              src={selectedProduct ? joinUrl(selectedProduct.image) : ""}
              sx={{ width: 140, height: 140, mx: "auto", border: `4px solid ${alpha(primaryMain, 0.1)}`, bgcolor: '#f9f9f9' }}
            />
          </Box>

          <Typography variant="h5" sx={{ fontWeight: 1000, mb: 0.5 }}>{isRtl ? selectedProduct?.title_ar : selectedProduct?.title_en}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>{isRtl ? "اختر الكمية المطلوبة" : "Choose the desired quantity"}</Typography>

          {/* QUANTITY SLIDER / SWIPE CONTROL */}
          <Box sx={{ px: 4, mb: 5 }}>
            <Stack direction="row" spacing={3} alignItems="center" justifyContent="center" sx={{ mb: 2 }}>
              <IconButton
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                sx={{ bgcolor: alpha(primaryMain, 0.1), color: primaryMain, '&:hover': { bgcolor: primaryMain, color: '#fff' } }}
              >
                <Remove />
              </IconButton>
              <Typography variant="h2" sx={{ fontWeight: 1000, minWidth: 60, color: primaryMain }}>{quantity}</Typography>
              <IconButton
                onClick={() => setQuantity(quantity + 1)}
                sx={{ bgcolor: alpha(primaryMain, 0.1), color: primaryMain, '&:hover': { bgcolor: primaryMain, color: '#fff' } }}
              >
                <Add />
              </IconButton>
            </Stack>
          </Box>

          <Button
            fullWidth
            variant="contained"
            onClick={confirmOrder}
            disabled={orderLoading}
            sx={{ borderRadius: 4, py: 2, fontWeight: 900, fontSize: '1.1rem' }}
          >
            {orderLoading ? <CircularProgress size={24} color="inherit" /> : (isRtl ? `تأكيد الطلب (${quantity * (selectedProduct?.price || 0)} ج.م)` : `Confirm Order`)}
          </Button>
        </Box>
      </Dialog>

      <UserQRCode open={qrOpen} onClose={() => setQrOpen(false)} user={user} />

      <BookingContactModal
        open={bookDialogOpen}
        onClose={() => setBookDialogOpen(false)}
        bookingType={bookingModalType}
        itemTitle={bookingModalTitle}
        room={selectedRoom}
      />
    </Box>
  );
}